import React from "react";
import Content from "../components/Content";
import AutoScaler from "../components/AutoScaler";

const LayoutLogin = ({ children }) => {
  return (
    <AutoScaler>
      <div className="Layout">
        <Content>{children}</Content>
      </div>
    </AutoScaler>
  );
};
export default LayoutLogin;